export const pharmacyLoginActions = {
  LOGIN_PHARMACY: {
    REQUEST: 'login/loginPharmacyRequest',
    SUCCESS: 'login/loginPharmacySuccess',
    FAILURE: 'login/loginPharmacyFailure',
    RESET: 'login/loginPharmacyReset'
  }
};
export const pharmacyLogoutActions = {
  LOGOUT_PHARMACY: {
    REQUEST: 'login/logoutPharmacyRequest',
    SUCCESS: 'login/logoutPharmacySuccess',
    FAILURE: 'login/logoutPharmacyFailure',
    RESET: 'login/logoutPharmacyReset'
  }
};
